"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.selectNotificationByKey = exports.hasNotifications = exports.selectCurrentNotification = void 0;
function selectCurrentNotification(state) {
    var _a, _b;
    return (_a = state.notifications) === null || _a === void 0 ? void 0 : _a[((_b = state.notifications) === null || _b === void 0 ? void 0 : _b.length) - 1];
}
exports.selectCurrentNotification = selectCurrentNotification;
function hasNotifications(state) {
    var _a;
    return !!((_a = state.notifications) === null || _a === void 0 ? void 0 : _a.length);
}
exports.hasNotifications = hasNotifications;
function selectNotificationByKey(state, key) {
    return state.notifications.find(function (notification) { return notification.key === key; });
}
exports.selectNotificationByKey = selectNotificationByKey;
//# sourceMappingURL=notifications.js.map